$(document).on('change', '.csv-import', function(e) {
  $('#csv-loading-element').addClass('loading');
  $('#csv-loading-element').css('display', 'block');
  $('.csv-form-file').submit();
});
